import { BasicController } from "@goodgamestudios/core";
import { BasicLogoutCommand } from "@goodgamestudios/core";

import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";

import { Poker2Model } from "../../model/Poker2Model";

export class Poker2LogoutCommand extends BasicLogoutCommand {
    public execute(commandVars: any = null): void {
        BasicController.getInstance().soundController.stopMusic();
        BasicController.getInstance().soundController.stopAllLoopedSoundEffects();
        Poker2Model.sessionData.resetLoggedinTimer();
        super.execute(commandVars);
    }
}

classImplementsInterfaces(Poker2LogoutCommand, "ISimpleCommand");
